type CommonState = {
  isGlobalLoading: boolean;
  isSessionExpiredDialogOpen: boolean;
  label: string;
  strappiCoreSettings: Record<string, any>;
  isShownCookieDialog: boolean;
  appConfig: Record<string, any>;
};

type MenuItem = {
  strapiKey?: string;
  [key: string]: unknown;
};

export default {
  namespaced: true,
  state: {
    isGlobalLoading: false,
    isSessionExpiredDialogOpen: false,
    label: '',
    strappiCoreSettings: {},
    isShownCookieDialog: false,
    appConfig: {},
  } as CommonState,
  mutations: {
    changeCookieDialogOpenState(state: CommonState, isShown: boolean) {
      state.isShownCookieDialog = isShown;
    },
    setGlobalLoading(state: CommonState, isGlobalLoading: boolean) {
      state.isGlobalLoading = isGlobalLoading;
    },
    setLabel(state: CommonState, label: string) {
      state.label = label;
    },
    changeSessionExpiredDialogOpenState(state: CommonState, dialogState: boolean) {
      state.isSessionExpiredDialogOpen = dialogState;
    },
    setStrappiCoreSettings(state: CommonState, data: Record<string, any>) {
      state.strappiCoreSettings = data;
    },
    setAppConfig(state: CommonState, data: Record<string, any>) {
      state.appConfig = data;
    },
  },
  actions: {
  },
  getters: {
    getAppConfig: (state: CommonState) => state.appConfig,
    isGlobalLoading: (state: CommonState) => state.isGlobalLoading,
    getIsShownCookieDialog: (state: CommonState) => state.isShownCookieDialog,
    getLabel: (state: CommonState) => state.label,
    getIsSessionExpiredDialogOpen: (state: CommonState) => state.isSessionExpiredDialogOpen,
    getStrappiCoreSettings: (state: CommonState) => state.strappiCoreSettings,
    getStrappiCoreMenu: (state: CommonState) => (menuItems: MenuItem[]) => menuItems.map((menuItem) => {
      if (state.strappiCoreSettings.navLinks) {
        let strapiMenuItem = '';
        Object.keys(state.strappiCoreSettings.navLinks)
          .forEach((key) => {
            if (key === menuItem.strapiKey) {
              strapiMenuItem = state.strappiCoreSettings.navLinks[key];
            }
          });
        return {
          ...menuItem,
          strapiText: strapiMenuItem,
        };
      }
      return menuItem;
    }),
  },
};
